import React, { ReactElement, useRef } from "react";
import { useSelector } from "react-redux";

import { useAppDispatch } from "../../app/store";
import Input, { InputController } from "../../components/forms/Input";
import WithDirtyDot from "../../components/WithDirtyDot";
import {
  selectFlowDirty,
  selectFlowName,
  selectFlowOwnership,
  selectUpdating,
  updateFlow,
} from "./flowEditorSlice";
import styles from "./NameEditor.module.css";

export default function NameEditor({
  onUpdate,
}: {
  onUpdate?: (value: string) => void;
}): ReactElement | null {
  const dispatch = useAppDispatch();

  const name = useSelector(selectFlowName);
  const dirty = useSelector(selectFlowDirty);
  const ownership = useSelector(selectFlowOwnership);
  const [updating] = useSelector(selectUpdating);

  const inputController = useRef<InputController>();

  if (name == null) return null;

  return (
    <div className={styles.root}>
      <WithDirtyDot className={styles.dirtyDot} isDirty={dirty ?? false}>
        <Input
          className={styles.editor}
          type="text"
          value={name}
          disabled={ownership !== "own" || updating === "pending"}
          isStatic={ownership !== "own"}
          onBlurValue={async (value) => {
            const name = value.trim();
            if (name !== "") {
              await dispatch(updateFlow({ name }));
              onUpdate?.(name);
            }
            inputController.current?.resetLocalValue();
          }}
          blurOnEnterOrEsc
          autoExpand
          controller={(c) => (inputController.current = c)}
        />
      </WithDirtyDot>
    </div>
  );
}
